module.exports = __webpack_public_path__ + "img/synthesis_popup_bg.bceb291d.png";